import DocumentService from 'aurora-composition/services/documentService';
import BuyersListService from 'aurora-composition/services/buyersListService';
import * as types from './constants';

// eslint-disable-next-line consistent-return
export const fetchNationalities = () => async dispatch => {
  try {
    const res = await BuyersListService.getNationalities();

    const locale = localStorage.getItem('lang');
    dispatch({
      type: types.FETCH_NATIONALITIES,
      payload: {
        nationalities: res?.nationalities?.map(national => ({
          value: national.nationalityid,
          label: locale === 'ar' ? national.nationalitynameAr : national.nationalitynameEn,
        })),
      },
    });
  } catch (error) {
    console.log('ERROR!!', error);
  }
};

const operationStart = () => ({
  type: types.BUYER_LIST_OPERATION_START,
});

const operationEnd = error => ({
  type: types.BUYER_LIST_OPERATION_END,
  payload: { error: error?.data?.result?.description || error?.message },
});

// eslint-disable-next-line
export const fetchBuyerList = ({
  page,
  PAGE_SIZE,
  filters,
  defaultFilters,
}) => async (dispatch) => {
  try {
    dispatch(operationStart());

    const payload = {
      pageNumber: +page,
      size: PAGE_SIZE,
      mobileNo: filters.mobileNumber && filters.mobileNumber?.replace(/\s/g, ''),
      passportNumber: filters.passportNumber && filters.passportNumber,
      nationalityId: filters.nationalityId && filters.nationalityId,
      email: filters.email && filters.email,
      nonResident: true,
      ...defaultFilters,
    };

    const res = await BuyersListService.fetchBuyerList(payload);

    dispatch({
      type: types.FETCH_BUYER_LIST,
      payload: { query: JSON.stringify(payload), buyerList: res.data }, // res.result
    });
    // return res;
  } catch (error) {
    dispatch(operationEnd(error));
  }
};

const onProceedStart = () => ({
  type: types.ON_PROCEED_VALIDATION_START,
});

const onProceedEnd = error => ({
  type: types.ON_PROCEED_VALIDATION_END,
  payload: { error: error?.data?.result?.description || error?.message },
});
export const fetchOnProceedValidation = property => async dispatch => {
  try {
    dispatch(onProceedStart());

    const passportExpiryDate = new Date(property?.userDetails?.passportExpiryDate);
    const today = new Date();
    const isExpired = today > passportExpiryDate;
    dispatch({
      type: types.ON_PROCEED_VALIDATION,
      payload: {
        buyerSelected: property,
        isExpired,
        addBuyerModal: !isExpired,
      }, // res.result
    });
  } catch (error) {
    dispatch(onProceedEnd(error));
  }
};

export const closeBuyerModal = () => dispatch => {
  dispatch({
    type: types.CLOSE_BUYER_MODAL,
    payload: {
      buyerSelected: null,
      isExpired: false,
      addBuyerModal: false,
    },
  });
};

export const uploadDocument = (body, params) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.UPLOAD_BUYER_DOCUMENT_START });

    const { documents } = getState().buyersListReducer;

    const document = await DocumentService.uploadDocument(body, params);

    dispatch({
      type: types.UPLOAD_BUYER_DOCUMENT,
      payload: { documents: [...documents, document.result] },
    });
  } catch (error) {
    dispatch({
      type: types.UPLOAD_BUYER_DOCUMENT_ERROR,
      payload: { error: error?.data?.result?.description || error?.message },
    });
  }
};

export const deleteDocument = (params, file) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.UPLOAD_BUYER_DOCUMENT_START });

    const { documents } = getState().buyersListReducer;

    await DocumentService.deleteDocument(params);

    dispatch({
      type: types.UPLOAD_BUYER_DOCUMENT,
      payload: { documents: documents.filter(doc => doc.id !== file.id) },
    });
  } catch (error) {
    dispatch({ type: types.UPLOAD_BUYER_DOCUMENT_ERROR, payload: error });
  }
};
// eslint-disable-next-line
export const addBuyer = (buyerSelected) => async (dispatch, getState) => {
  try {
    dispatch(onProceedStart());
    const { applicationId } = getState().offPlanReducer;
    const body = {
      email: buyerSelected?.email,
      phoneNumber: buyerSelected?.mobileNumber,
      applicationId,
      userId: buyerSelected?.userId,
    };

    const res = await BuyersListService.addBuyer(body);

    res?.success && dispatch(closeBuyerModal());

    dispatch({
      type: types.ADD_BUYER_SUCCESS,
      payload: {}, // res.result
    });

    return res;
  } catch (error) {
    dispatch(onProceedEnd(error));
    return error;
  }
};
